import { useContext, useEffect } from 'react'

import { AnnouncerContext } from './LiveAnnouncerProvider'
import { AriaMessageType } from '@thg-commerce/gravity-elements'

interface LiveMessageProps {
  ariaLive: AriaMessageType
  message: string
}

export const LiveMessage = (props: LiveMessageProps) => {
  const announcementContext = useContext(AnnouncerContext)
  const { message, ariaLive } = props

  useEffect(() => {
    announce()
  }, [])

  useEffect(() => {
    announce()
  }, [props])

  const announce = () => {
    if (ariaLive === 'assertive') {
      announcementContext.announceAssertiveMessage(message)
    } else if (ariaLive === 'polite') {
      announcementContext.announcePoliteMessage(message)
    }
  }

  return null
}

export default LiveMessage
